import { render, staticRenderFns } from "./People.vue?vue&type=template&id=7594a5cc&"
import script from "./People.vue?vue&type=script&lang=js&"
export * from "./People.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7594a5cc')) {
      api.createRecord('7594a5cc', component.options)
    } else {
      api.reload('7594a5cc', component.options)
    }
    module.hot.accept("./People.vue?vue&type=template&id=7594a5cc&", function () {
      api.rerender('7594a5cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/items/People.vue"
export default component.exports